<div
  class="menu-wrapper"
  [ngClass]="{
    'layout-sidebar-active': appMain.sidebarActive,
    'sidebar-static': sidebarStatic,
    'layout-mobile-active': sidebarMobileActive
  }"
  (click)="appMain.onSidebarClick($event)"
  (mouseover)="appMain.onSidebarMouseOver($event)"
  (mouseleave)="appMain.onSidebarMouseLeave($event)"
>
  <div
    class="sidebar-logo"
    [class.hidden]="!isSideBarDisabled"
  >
    <a
      [routerLink]="['/']"
      class="logo-img"
      [class.darkMode]="(colorSchemeService.colorScheme | async) === 'dark'"
    >
      <svg
        width="499"
        viewBox="0 0 499 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M159.88 60.4861C139.918 41.7482 115.69 49.9994 103.342 58.1035C102.03 58.9644 102.449 61.1774 103.858 61.8676C107.258 63.5331 112.15 66.8414 117.488 72.7466C125.468 81.5743 119.15 82.1465 114.994 81.3291C102.448 62.3482 77.9948 64.7935 66.2571 68.674C65.5645 68.903 65.0992 69.5604 65.0571 70.2886C63.89 90.4767 57.9988 86.1388 55.1457 81.3291C57.2238 76.8335 60.6318 64.8997 57.6394 53.1294C54.6469 41.3591 58.8862 35.147 61.3799 33.5123C71.3546 44.3017 78.8357 35.556 81.3294 29.8345C89.3845 10.0324 70.8778 3.28963 54.7012 1.8582C47.8788 1.25449 41.4948 4.7315 37.7549 10.4694C30.671 21.3377 19.9527 39.7794 9.01233 64.1646C-5.94978 97.5137 2.77812 112.39 9.01233 115.66C69.8582 149.009 134.943 129.555 159.88 115.66V60.4861Z"
          fill="#75BF43"
        />
        <path
          d="M339.77 60.4861C359.732 41.7482 383.96 49.9994 396.308 58.1035C397.619 58.9644 397.201 61.1774 395.792 61.8676C392.392 63.5331 387.5 66.8414 382.162 72.7466C374.182 81.5743 380.5 82.1465 384.656 81.3291C397.202 62.3482 421.655 64.7935 433.393 68.674C434.085 68.903 434.551 69.5604 434.593 70.2886C435.76 90.4767 441.651 86.1388 444.504 81.3291C442.426 76.8335 439.018 64.8997 442.011 53.1294C445.003 41.3591 440.764 35.147 438.27 33.5123C428.295 44.3017 420.814 35.556 418.321 29.8345C410.265 10.0324 428.772 3.28963 444.949 1.8582C451.771 1.25449 458.155 4.7315 461.895 10.4694C468.979 21.3377 479.697 39.7794 490.638 64.1646C505.6 97.5137 496.872 112.39 490.638 115.66C429.792 149.009 364.707 129.555 339.77 115.66V60.4861Z"
          fill="#75BF43"
        />
        <path
          d="M170.442 0.50293L249.825 10.2801L329.208 0.50293L349.053 39.6116L329.208 45.4167L279.593 59.1659L261.608 29.8344L249.825 10.2801L237.731 29.8344L220.056 59.1659L170.442 45.4167L150.596 39.6116L170.442 0.50293ZM170.442 117.829V55.4994L217.265 68.6375L224.397 70.7762L228.428 64.36L249.204 29.8344H250.135L270.911 64.36L274.942 70.7762L282.074 68.6375L329.208 55.4994V117.829L249.825 137.383L170.442 117.829Z"
          fill="#75BF43"
        />
      </svg>

      <span [class.hidden]="!appMain.sidebarActive && !sidebarMobileActive">
        MOVERIGHT
      </span>
    </a>
    <a
      href="#"
      class="sidebar-pin"
      (click)="appMain.onToggleMenu($event)"
    >
      <svg
        id="pin-solid"
        *ngIf="appMain.sidebarStatic"
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.37427 1.64557C1.37427 1.11432 1.81177 0.645569 2.37427 0.645569H10.3743C10.9055 0.645569 11.3743 1.11432 11.3743 1.64557C11.3743 2.20807 10.9055 2.64557 10.3743 2.64557H9.43677L9.78052 7.30182C10.9368 7.92682 11.843 8.95807 12.2805 10.2393L12.3118 10.3331C12.4055 10.6456 12.3743 10.9893 12.1868 11.2393C11.9993 11.4893 11.6868 11.6456 11.3743 11.6456H1.37427C1.03052 11.6456 0.749268 11.5206 0.561768 11.2393C0.343018 10.9893 0.311768 10.6456 0.405518 10.3331L0.436768 10.2393C0.874268 8.95807 1.78052 7.92682 2.93677 7.30182L3.28052 2.64557H2.37427C1.81177 2.64557 1.37427 2.20807 1.37427 1.64557ZM5.37427 12.6456H7.37427V15.6456C7.37427 16.2081 6.90552 16.6456 6.37427 16.6456C5.81177 16.6456 5.37427 16.2081 5.37427 15.6456V12.6456Z"
          fill="black"
        />
      </svg>

      <svg
        id="pin-outlined"
        *ngIf="!appMain.sidebarStatic"
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.93176 1.82196L4.58801 6.22821C4.55676 6.69696 4.33801 7.10321 3.93176 7.35321C3.21301 7.85321 2.65051 8.63446 2.40051 9.54071L2.36926 9.69696H5.99426V6.94696C5.99426 6.54071 6.30676 6.19696 6.74426 6.19696C7.15051 6.19696 7.49426 6.54071 7.49426 6.94696V9.69696H11.088L11.0568 9.54071C10.8068 8.63446 10.2755 7.85321 9.52551 7.35321C9.15051 7.10321 8.90051 6.69696 8.86926 6.22821L8.52551 1.82196C8.52551 1.79071 8.52551 1.75946 8.52551 1.69696L4.93176 1.69696C4.93176 1.75946 4.93176 1.79071 4.93176 1.82196ZM5.99426 11.197H1.74426C1.43176 11.197 1.11926 11.072 0.931763 10.822C0.744263 10.572 0.681763 10.2595 0.775513 9.97821L0.963013 9.19696C1.27551 7.88446 2.05676 6.82196 3.08801 6.10321L3.33801 3.19696L3.43176 1.69696H2.49426C2.33801 1.69696 2.21301 1.66571 2.08801 1.60321C1.86926 1.47821 1.74426 1.22821 1.74426 0.94696C1.74426 0.54071 2.05676 0.19696 2.49426 0.19696H3.43176L10.0255 0.19696H10.9943C11.4005 0.19696 11.7443 0.54071 11.7443 0.94696C11.7443 1.22821 11.588 1.47821 11.3693 1.60321C11.2443 1.66571 11.1193 1.69696 10.9943 1.69696H10.0255L10.1193 3.19696L10.3693 6.10321C11.4005 6.82196 12.1818 7.88446 12.4943 9.19696L12.6818 9.97821C12.7755 10.2595 12.713 10.572 12.5255 10.822C12.338 11.072 12.0255 11.197 11.713 11.197H7.49426V15.447C7.49426 15.8845 7.15051 16.197 6.74426 16.197C6.30676 16.197 5.99426 15.8845 5.99426 15.447V11.197Z"
          fill="black"
        />
      </svg>
    </a>
  </div>
  <div
    [class.hide]="!(appMain.sidebarActive || appMain.staticMenuMobileActive)"
    class="zone-select-container"
  >
    <app-zone-select></app-zone-select>
  </div>
  <div
    class="p-text-center"
    *ngIf="appMain.sidebarActive || appMain.staticMenuMobileActive"
  >
    <small>{{ (branding.currentBranding | async).timezone }}</small>
  </div>
  <div
    class="needs-attention menu-row"
    *hasPermission="['frontend.needs-attention']"
    [class.hidden]="!isSideBarDisabled"
  >
    <a
      *ngIf="
        (appMain.sidebarActive || appMain.staticMenuMobileActive) &&
          attentionItemsTotal$ | async as total
      "
      routerLink="/needs-attention"
    >
      <i class="pi pi-exclamation-circle p-mr-2"></i>
      <span>Needs Attention: {{ total }}</span>
    </a>
  </div>

  <div
    *ngIf="(appMain.sidebarActive || appMain.staticMenuMobileActive) && menuService.isJobCreationToolEnabled"
    class="new-opportunity menu-row"
    [class.hidden]="!isSideBarDisabled"
  >
    <a [routerLink]="'/jobs/new'">
      <i class="pi pi-plus"></i>
      <span>{{ createJobButtonLabel }}</span>
    </a>
  </div>

  <div
    #menuRef
    class="layout-menu-container"
  >
    <app-quick-access
      *ngIf="(appMain.sidebarActive || appMain.staticMenuMobileActive) && menuService.isQuickAccessEnabled"
      class="quick-access menu-row"
      [class.hidden]="!isSideBarDisabled"
    >

    </app-quick-access>

    <ul
      class="layout-menu"
      data-cy="layout-menu"
    >
      <ng-template
        ngFor
        let-item
        [ngForOf]="menuService.sidebar"
        let-i="index"
        [ngForTrackBy]="trackID"
      >
        <li
          *hasPermission="
            item.permissions;
            showByDefault: !item.hiddenByDefault
          "
          app-menuitem
          [hidden]="
            item.hidden ||
            (item.hiddenIfZoneType &&
              item.hiddenIfZoneType.includes(
                (branding.currentZone | async).type
              ))
          "
          [item]="item"
          [index]="i"
          [root]="true"
        ></li>
      </ng-template>
    </ul>
  </div>
  <div
    #recentItemsRef
    class="recent-items"
    *ngIf="!menuService.isQuickAccessEnabled"
  >
    <p-panel
      [toggleable]="true"
      expandIcon="pi pi-chevron-up"
      collapseIcon="pi pi-chevron-down"
      toggler="header"
      [(collapsed)]="recentItems.pinnedItemsCollapsed"
    >
      <ng-template pTemplate="header">
        <span class="p-panel-header-title">
          <div class="p-panel-header-icon">
            <i class="pi mi-pin"></i>
          </div>
          <span
            class="p-panel-header-label"
            [class.hide]="
              !(appMain.sidebarActive || appMain.staticMenuMobileActive)
            "
          >Pinned Items ({{ recentItems.pinnedItemsInZone.length }}/{{
            recentItems.maxPinnedItemsPerZone
            }})</span>
        </span>
        <app-info-circle
          class="info-circle"
          [hidden]="!(appMain.sidebarActive || appMain.staticMenuMobileActive)"
          pTooltip="To pin an item, click the item's action button and select the pin action."
        ></app-info-circle>
      </ng-template>
      <div
        *ngIf="!recentItems.pinnedItemsInZone.length"
        class="no-items"
      >
        <p>
          <small>Here is where your pinned items will appear. Pinning an item allows
            for quick access to it.</small>
        </p>
        <p>
          <small>To pin an item, click the item's actions button and select the pin
            action.</small>
        </p>
        <p>
          <small>Currently not all items can be pinned but we will be expanding this
            in the future.</small>
        </p>
      </div>
      <div
        [@recentItems]="recentItems.pinnedItemsInZone.length"
        *ngFor="let item of recentItems.pinnedItemsInZone"
        class="pinned-item"
      >
        <div>
          <button
            pButton
            pTooltip="Unpin item"
            type="button"
            icon="pi mi-pin-fill"
            (click)="recentItems.unpinItem(item)"
          ></button>
        </div>
        <div
          class="item-link"
          (click)="recentItems.openItem(item); appMain.onLayoutClick()"
        >
          <i [class]="
              item.type === 'artifact'
                ? (item.displayType | artifactTypeIcon)
                : entityIcons[item.type]
            "></i>
          <span class="item-name">
            {{ item.displayType }}
            <small>
              {{ item.name }}
            </small>
          </span>
        </div>
      </div>
    </p-panel>
    <p-panel
      [toggleable]="true"
      expandIcon="pi pi-chevron-up"
      collapseIcon="pi pi-chevron-down"
      toggler="header"
      [(collapsed)]="recentItems.recentItemsCollapsed"
      styleClass="recent-items-panel"
    >
      <ng-template pTemplate="header">
        <span class="p-panel-header-title">
          <div class="p-panel-header-icon">
            <i class="pi pi-clock"></i>
          </div>
          <span
            class="p-panel-header-label"
            [class.hide]="
              !(appMain.sidebarActive || appMain.staticMenuMobileActive)
            "
          >Recent Items</span>
        </span>
        <app-info-circle
          class="info-circle"
          [hidden]="!(appMain.sidebarActive || appMain.staticMenuMobileActive)"
          pTooltip="Whenever you visit an item's page, the item gets added here."
        ></app-info-circle>
      </ng-template>
      <div
        *ngIf="!recentItems.recentItemsInZone.length"
        class="no-items"
      >
        <p>
          <small>Here is where your recent items will appear. Recent items records a
            list of the pages you have visited recently so you can quickly go
            back to an item.</small>
        </p>
      </div>
      <div
        [@recentItems]="recentItems.recentItemsInZone.length"
        *ngFor="let item of recentItems.recentItemsInZone"
        class="recent-item"
      >
        <div
          class="item-link"
          (click)="recentItems.openItem(item); appMain.onLayoutClick()"
        >
          <i [class]="entityIcons[item.type]"></i>
          <span class="item-name">
            {{ item.displayType }}
            <small>
              {{ item.name }}
            </small>
          </span>
        </div>
      </div>
    </p-panel>
  </div>
</div>